export class TooltipService {
  constructor() {
    this.timeout = null
  }

  setupTooltip(element, tooltipElement) {
    if (!tooltipElement) return

    element.addEventListener("mouseenter", () => {
      this.timeout = setTimeout(() => {
        this.showTooltip(element, tooltipElement)
      }, 800)
    })

    element.addEventListener("mouseleave", () => {
      this.hideTooltip(element, tooltipElement)
    })
  }

  showTooltip(element, tooltipElement) {
    // Move tooltip to body for proper z-index stacking
    document.body.appendChild(tooltipElement)

    tooltipElement.classList.remove("hidden")

    setTimeout(() => {
      const rect = element.getBoundingClientRect()
      tooltipElement.style.top = (rect.top - tooltipElement.offsetHeight - 20) + "px"
      tooltipElement.style.left = (rect.left + rect.width / 2 - tooltipElement.offsetWidth / 2) + "px"
    }, 0)

  }

  hideTooltip(element, tooltipElement) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    tooltipElement.classList.add("hidden")
    // Move tooltip back to its original parent
    element.parentElement.appendChild(tooltipElement)
  }
}
